import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

const LIGHT_LOGO = 'https://ik.imagekit.io/gr1ybccbs/DocxsAi-light.png';
const DARK_LOGO = 'https://ik.imagekit.io/gr1ybccbs/DocxsAi-dark.png';

/**
 * Theme-aware DocxsAi full logo (icon + wordmark).
 * Prefer logo alone where UI previously had img + "DocxsAi" text.
 */
const DocxsAiLogo = ({ className = 'h-8 w-auto', alt = 'DocxsAi' }) => {
  const { theme } = useTheme();
  const src = theme === 'dark' ? DARK_LOGO : LIGHT_LOGO;

  return <img src={src} alt={alt} className={className} />;
};

export default DocxsAiLogo;
export { LIGHT_LOGO, DARK_LOGO };
